export const responsive_breakpoints = {
  xxs: "0em",
  xs: "30em",
  sm: "48em",
  md: "64em",
  lg: "74em",
  xl: "90em",
};

export const announcement_bar_height = 36;
export const responsive_header_height = { base: 56, md: 64 };
export const pageMaxWidth = 1260;
export const pagePaddingX = { base: 16, sm: 24, md: 40 };

/** Standard vertical section padding */
export const sectionPy = { base: 40, md: 48 };

/** Tighter padding for stacked home-page sections */
export const homeSectionPy = { base: 32, md: 40 };

/**
 * Content breathing room below the in-flow site chrome (announcement + header).
 * Header already occupies layout space in AppShell — do not add chrome height again.
 */
export function pageTopSpacing(breathingRoom = 32) {
  return { base: breathingRoom, md: breathingRoom };
}

/** @deprecated Use pageTopSpacing */
export function contentTopPadding(extra = 12) {
  return pageTopSpacing(extra);
}
